module.exports = __webpack_public_path__ + "static/media/ClicMe-Android.86a1aef9.png";